import React from 'react'
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@material-ui/core'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import { logout, resetNewCampaign } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const AccountProfile = props => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.session?.user)
  const adminId = user?.adminId
  const adminFirstname = user?.adminFirstname
  const adminLastname = user?.adminLastname
  const adminEmail = user?.adminEmail
  const companyName = user?.companyName
  const phone = user?.phone
  const logo = user?.profilePhoto
  const userType = useSelector(state => state.session?.userType) || 'unknown'

  const handleLogout = () => {
    dispatch(resetNewCampaign('logout'))
    dispatch(logout())
    window.location.reload()
  }

  return (
    <Card {...props}>
      <CardContent
        style={{
          alignItems: 'center',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '-2em'
        }}>
        <Avatar
          src={logo}
          style={{
            width: '4em',
            height: '4em',
            margin: '0 .5em 0 1em',
            border: '2px solid white',
            boxShadow: '0px 4px 15px rgb(31 33 37 / 10%)'
          }}
        />
        <Typography
          style={{ paddingTop: '1em' }}
          color="textPrimary"
          variant="h5"
          gutterBottom>
          {`${adminFirstname || ''} ${adminLastname || ''}`}
        </Typography>
        <Typography style={{ paddingBottom: '1em' }} variant="body1">
          {adminEmail}
        </Typography>
        <Divider
          style={{
            width: '22em',
            backgroundColor: 'grey',
            marginBottom: '1em'
          }}
        />
        <Grid container justifyContent="space-between">
          <Grid item style={{ textAlign: 'left' }}>
            <Typography variant="h5">Company</Typography>
            <Typography variant="subtitle2" className="long-company-name">
              {companyName ?? 'Unknown'}
            </Typography>
            <Typography variant="h5">Membership ID</Typography>
            <Typography variant="subtitle2">#{adminId ?? 'Unknown'}</Typography>
          </Grid>
          <Grid item style={{ textAlign: 'left' }}>
            <Typography variant="h5">Membership Type</Typography>
            <Typography variant="subtitle2">{userType ?? 'Unknown'}</Typography>
            <Typography variant="h5">Phone Number</Typography>
            <Typography variant="subtitle2">{phone ?? 'Unknown'}</Typography>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions>
        <Button
          startIcon={<PowerSettingsNewIcon />}
          color="primary"
          variant="contained"
          onClick={handleLogout}
          fullWidth>
          Log out
        </Button>
      </CardActions>
    </Card>
  )
}

export default AccountProfile
